import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=65d80ebc&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d80ebc",
  null
  
)

export default component.exports